import {
  NewFormatConditionType,
  TransactionItemFieldIds,
} from "types/campaigns";

export const itemFilters = [
  {
    id: TransactionItemFieldIds.CATEGORY,
    label: "itemCategory",
    type: NewFormatConditionType.STRING,
  },
  {
    id: TransactionItemFieldIds.LABELS,
    label: "itemCustomAttributeValue",
    type: NewFormatConditionType.LABELS_ARRAY,
  },
  {
    id: TransactionItemFieldIds.NAME,
    label: "itemName",
    type: NewFormatConditionType.STRING,
  },
  {
    id: TransactionItemFieldIds.GROSS_VALUE,
    label: "itemPrice",
    type: NewFormatConditionType.NUMBER,
  },
  {
    id: TransactionItemFieldIds.SKU,
    label: "itemSku",
    type: NewFormatConditionType.STRING,
  },
  {
    id: TransactionItemFieldIds.MAKER,
    label: "itemBrand",
    type: NewFormatConditionType.STRING,
  },
];
